import { render, staticRenderFns } from "./labProduction_page.vue?vue&type=template&id=7bd7ae2a&scoped=true"
import script from "./labProduction_page.vue?vue&type=script&lang=js"
export * from "./labProduction_page.vue?vue&type=script&lang=js"
import style0 from "./labProduction_page.vue?vue&type=style&index=0&id=7bd7ae2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd7ae2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd7ae2a')) {
      api.createRecord('7bd7ae2a', component.options)
    } else {
      api.reload('7bd7ae2a', component.options)
    }
    module.hot.accept("./labProduction_page.vue?vue&type=template&id=7bd7ae2a&scoped=true", function () {
      api.rerender('7bd7ae2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/labProduction_page.vue"
export default component.exports